import React, { Component } from "react";
import { Row, Col, ProgressBar, Image, Button } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import DropdownComp from "../../components/commonDropdown";
import { Line } from "react-chartjs-2";

class TutorView extends Component {
  constructor() {
    super();

    this.state = {};
  }

  componentDidMount = () => {
    // get Token
    let token = JSON.parse(localStorage.getItem("userDetail"));
    token = `Bearer ${token?.token}`;
  };

  render() {
    const {} = this.state;
    let chartData = {
      labels: [
        "03",
        "05",
        "07",
        "9",
        "11",
        "13",
        "15",
        "17",
        "19",
        "21",
        "23",
        "25",
        "27",
        "29",
        "31",
      ],
      datasets: [
        {
          label: "View",
          data: [
            2,
            3,
            4,
            1,
            5,
            1,
            4,
            2,
            3,
            4,
            1,
            5,
            1,
            4,
            2,
            3,
            4,
            1,
            5,
            1,
            4,
            2,
            3,
            4,
            1,
            5,
            1,
            4,
            2,
            3,
            4,
          ],
          borderColor: "#108bc9",
          backgroundColor: "#108bc9",
          fill: false,
          pointRadius: 3,
          pointHoverRadius: 4,
          borderWidth: 2,
        },
      ],
    };

    return (
      <div className="tutor-earning-div">
        <Row className="tutor-earning-Row">
          <Col lg={4} md={4} sm={12} xs={12} className="money-Col">
            <div className="flex-center-center">
              <Image src={require("./../../assets/icons/pound-black.png")} />
              <h3> 30</h3>
            </div>
            <p>Jan 2020 views</p>
          </Col>
          <Col lg={4} md={4} sm={12} xs={12} className="money-Col">
            <div className="flex-center-center">
              <Image src={require("./../../assets/icons/pound-black.png")} />
              <h3>3</h3>
            </div>
            <p>Jan 2020 new bookings</p>
          </Col>
          <Col lg={4} md={4} sm={12} xs={12} className="money-Col">
            <div className="flex-center-center">
              <Image src={require("./../../assets/icons/pound-black.png")} />
              <h3> 1.4%</h3>
            </div>
            <p>Booking rate</p>
          </Col>
        </Row>
        <div style={{ marginBottom: "50px" }} />

        <Row style={{ margin: "0px" }}>
          <Col lg={12} md={12} sm={12} xs={12}>
            <Line data={chartData} />
          </Col>
          <div
            style={{
              marginTop: "50px",
            }}
          >
            <h4
              style={{
                color: "#828282",
                fontWeight: "400",
                fontSize: "20px",
              }}
            >
              Data may be delayed
            </h4>

            <div
              className="blue-txt"
              style={{
                textDecoration: "underLine",
                fontWeight: "500",
                fontSize: "20px",
                marginTop: "20px",
              }}
            >
              Give us feedback
            </div>
          </div>
        </Row>
        <div style={{ marginBottom: "50px" }} />
      </div>
    );
  }
}

export default TutorView;
